<template>
    <featured-top-spot-tyre
        :tyre="tyre"
        :basket="basket"
        :postcode="postcode"
        :banners="banners"
        :home-delivery="homeDelivery"
        :is-uber="isUber"
    ></featured-top-spot-tyre>
</template>
<script>
    export default {
        props: ['tyre', 'basket', 'postcode', 'banners', 'homeDelivery', 'isUber']
    }
</script>